import React from "react";
import AuditTrail from "../../../components/AuditTrail";
import { ApiURL } from "../../../services/apiConstants";

export default function AuditPage() {
  return <AuditTrail endpoint={ApiURL.orb_log_audit_log_com} partField="orb_part" part="2" />;
}
